import { Box, Skeleton, Typography } from "@mui/material";
import BuilderIOSection from '../../builderio/components/builderIOSection';
import { BuilderIOSections } from '../../models/constants';
import { useSelector } from "react-redux";
import { RootState } from "@/app/store/store";

interface ProductDetailsDocumentProps {
    attachmentId: number | null;
    fileName: string | null;
}

interface ProductDetailsSpecificationProps {
    name: string | null;
    value: string | null;
}

interface ProductSpecificationTabsProps {
    productId: Number;
    children?: React.ReactNode;
    brand: string | null;
    aboutText: string | null;
    embeddedVideo: string | null;
    specifications: ProductDetailsSpecificationProps[];
    documents: ProductDetailsDocumentProps[];
    loading: boolean;
    commonPDPBuilderData: any;
}

const ProductSpecificationFlat: React.FC<ProductSpecificationTabsProps> 
    = ({ productId, brand, aboutText, embeddedVideo, specifications, documents, loading, commonPDPBuilderData }) => {

    let aboutVisible = (aboutText !== null && aboutText !== "") || (embeddedVideo !== null && embeddedVideo !== "");
    let specificationsVisible = specifications.length > 0;
    let documentsVisible = documents.length > 0;

    const userId = useSelector((state: RootState) => state.userState.user?.id ?? null);

    return (
        <Box sx={{ width: '100%', borderTop: 1, borderColor: 'divider', mt: 8, pt: 5, mb: 2 }}>
            {aboutVisible ? (
                <Box>
                    {loading ?
                        <Skeleton variant="rectangular" animation="wave" height={80} /> :
                        <>
                             <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                                <span className="flatProductSpecificationHeader" style={{ width: '100%' }}>About</span>
                            </Box>
                            
                            <BuilderIOSection section={BuilderIOSections.PDPProductAboutSection} data={{
                                ...commonPDPBuilderData,
                                aboutText: aboutText ?? "",
                                embeddedVideo: embeddedVideo ?? ""
                            }} />
                            {/* <SafeHtml as="div" className="content" html={aboutText ?? ""} />
                    <SafeHtml as="div" html={embeddedVideo ?? ""} /> */}
                        </>
                    }
                </Box>
            ) : <></>}
            {specificationsVisible ? (
                <Box>
                    {loading ? <Skeleton variant="rectangular" animation="wave" height={80} /> :
                        <>
                            <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                                <span className="flatProductSpecificationHeader" style={{ width: '100%' }}>Specifications</span>
                            </Box>
                            {
                                specifications.map(specification => (
                                    <div key={specification.name}>
                                        <BuilderIOSection section={BuilderIOSections.PDPProductSpecificationSection} data={{
                                            ...commonPDPBuilderData,
                                            specificationName: specification.name,
                                            specificationValue: specification.value
                                        }} />
                                        {/* <span>{specification.name}: </span>
                                        <b>{specification.value}</b> */}
                                    </div>
                                ))
                            }
                        </>}
                </Box>
            ) : <></>}
            {documentsVisible ? (
                <Box>
                    {loading ? <Skeleton variant="rectangular" animation="wave" width={"100%"} height={80} /> :
                        <>
                            <Box sx={{ width: '100%', borderBottom: 1, borderColor: 'divider', mb: 3 }}>
                                <span className="flatProductSpecificationHeader" style={{ width: '100%' }}>Documents</span>
                            </Box>
                            {
                                documents.map(document => (
                                    <div key={document.fileName} className='tabSpecificationList'>
                                        <BuilderIOSection section={BuilderIOSections.PDPProductDocumentSection}
                                         data={{
                                            ...commonPDPBuilderData,
                                            attachmentId: document.attachmentId,
                                            documentUrl: process.env.REACT_APP_BASE_API_URL + `/v1.0/products/${productId}/attachment/${document.attachmentId}${userId ? `?userId=${userId}` : ''}`,
                                            fileName: document.fileName
                                        }} />
                                        {/* <a href={VersionUrl(process.env.REACT_APP_API_URL + "/GetProductAttachment") + "&id=" + document.attachmentId} target='_blank' rel="noreferrer">{document.fileName}</a> */}
                                    </div>
                                ))
                            }
                        </>
                    }
                    <Typography variant="caption" display="block" gutterBottom style={{ marginTop: "20px" }}>
                        {loading ? <Skeleton /> : <>To read PDF files, you need the Adobe Acrobat Reader 6.0 or higher. <a href="https://get.adobe.com/reader/" target="_blank" rel="noreferrer">Click here</a> to download it for free from Adobe's site.</>}
                    </Typography>
                </Box>
            ) : <></>}
        </Box>
    );
}

export default ProductSpecificationFlat;